import { hasKey, hasMinimumLength } from '@/utils/resultsHelper';
import { clientError } from '@/utils/errors';
import fields, { globalFieldLengths } from '@/constants/fields';

export const collectionsMetrics = ({ collections }) => ({
  all_collections: collections.length,
});

export const validateCollection = (collection, intl) => {
  const errors = [];

  if (collection) {
    if (hasKey(collection, 'name') && !hasMinimumLength(collection.name)) {
      errors.push(clientError(
        { entity: 'collection' },
        intl.formatMessage({ id: 'save.collection.validation.required.name.title' }),
        intl.formatMessage({ id: 'save.collection.validation.required.name' }),
        [fields.NAME],
      ));
    }

    if (collection.name && collection.name.length > globalFieldLengths.name) {
      errors.push(clientError(
        { entity: 'collection' },
        intl.formatMessage({ id: 'save.collection.validation.name.title' }),
        intl.formatMessage({ id: 'validation.max.length' }, { maximum: globalFieldLengths.name }),
        [fields.NAME],
      ));
    }

    if (collection.description
        && collection.description.length > globalFieldLengths.description) {
      errors.push(clientError(
        { entity: 'collection' },
        intl.formatMessage({ id: 'save.collection.validation.description.title' }),
        intl.formatMessage({ id: 'validation.max.length' }, { maximum: globalFieldLengths.description }),
        [fields.DESCRIPTION],
      ));
    }
  }

  return errors;
};

export const collectionUppyId = (collection) => {
  if (!collection) {
    return null;
  }
  return `collections-logo-${collection.previousCode || collection.code}`;
};

const collectionDiff = (collection) => {
  const fieldsToCompare = ['name', 'description'];
  const diff = {};
  fieldsToCompare.forEach((field) => {
    if (collection[field] !== collection.copy[field]) {
      diff[field] = collection[field];
    }
  });
  return Object.keys(diff).length > 0 ? diff : null;
};

export default collectionDiff;
